"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const tsyringe_1 = require("tsyringe");
const oidc_client_ext_1 = require("@inrupt/oidc-client-ext");
let LegacyImplicitFlowOidcHandler = class LegacyImplicitFlowOidcHandler {
    constructor(sessionInfoManager, redirector, storageUtility) {
        this.sessionInfoManager = sessionInfoManager;
        this.redirector = redirector;
        this.storageUtility = storageUtility;
    }
    async canHandle(oidcLoginOptions) {
        return !!(oidcLoginOptions.issuerConfiguration.grantTypesSupported &&
            oidcLoginOptions.issuerConfiguration.grantTypesSupported.indexOf("implicit") > -1);
    }
    async handle(oidcLoginOptions) {
        const query = {
            client_id: oidcLoginOptions.client.clientId,
            response_type: "id_token token",
            redirect_uri: oidcLoginOptions.redirectUrl,
            scope: "openid webid offline_access",
            state: oidcLoginOptions.sessionId,
        };
        const [key] = await Promise.all([
            oidc_client_ext_1.generateJwkForDpop(),
            this.storageUtility.setForUser(oidcLoginOptions.sessionId, {
                isLoggedIn: "false",
                sessionId: oidcLoginOptions.sessionId,
            }, { secure: true }),
        ]);
        if (oidcLoginOptions.dpop) {
            query.dpop = await oidc_client_ext_1.createDpopHeader(oidcLoginOptions.issuer, "GET", key);
        }
        const sessionInfo = await this.sessionInfoManager.get(oidcLoginOptions.sessionId);
        if (!sessionInfo) {
            throw new Error("There was a problem creating a session.");
        }
        const requestUrl = new URL(oidcLoginOptions.issuerConfiguration.authorizationEndpoint);
        for (const queryParamkey of Object.keys(query)) {
            requestUrl.searchParams.set(queryParamkey, query[queryParamkey]);
        }
        this.redirector.redirect(requestUrl.toString(), {
            handleRedirect: oidcLoginOptions.handleRedirect,
        });
    }
};
LegacyImplicitFlowOidcHandler = __decorate([
    tsyringe_1.injectable(),
    __param(0, tsyringe_1.inject("sessionInfoManager")),
    __param(1, tsyringe_1.inject("redirector")),
    __param(2, tsyringe_1.inject("storageUtility")),
    __metadata("design:paramtypes", [Object, Object, Object])
], LegacyImplicitFlowOidcHandler);
exports.default = LegacyImplicitFlowOidcHandler;
//# sourceMappingURL=LegacyImplicitFlowOidcHandler.js.map